<template>
    <div>
        <p>Vui lòng nhắn tin vào <span class="bold">nhóm Đối ngoại/Test của văn phòng</span> để được hướng dẫn đăng ký test.</p>
        <p class="bold">Cú pháp nhắn tin:</p>
        <p>Em có khách hàng <span class="bold">[Tên KH – SĐT]</span> muốn test đầu vào<span class="bold"> Cấp 2 (Speaking &amp; General)</span> vào ngày … giờ …</p>
        <p>Nhờ anh/chị Admin hỗ trợ ạ.</p>

        <div class="example">
            <p class="bold">Ví dụ:</p>
            <p>
                Em có khách hàng Nguyễn Văn A - 0987654321 muốn test đầu vào
                Cấp 2 (Speaking &amp; General) ngày 25/10 lúc 15h.
            </p>
            <p>Nhờ anh/chị Admin hỗ trợ ạ.</p>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.bold {
    font-weight: bold;
}
.example {
    margin-top: 16px;
}
</style>
